var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._g(_vm._b({staticClass:"mt-1",attrs:{"error-messages":_vm.errors,"outlined":"","dense":""},on:{"input":_vm.duplicateCheckInputHandler}},'v-text-field',_vm.$props,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }